(function () {
  if (window.GarrnishIngredientListModal) {
    window.GarrnishIngredientListModal.init(document);
    return;
  }

  function unlockPage() {
    if (!document.querySelector('.ingredient-list-modal[open]')) {
      document.documentElement.classList.remove('ingredient-list-modal-open');
    }
  }

  function bindDialog(dialog) {
    if (!dialog || dialog.dataset.ingredientListBound === 'true') return;
    dialog.dataset.ingredientListBound = 'true';

    dialog.addEventListener('click', function (event) {
      if (event.target.closest('[data-ingredient-list-close]') || event.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', function () {
      unlockPage();
      var triggerId = dialog.dataset.returnFocusId;
      var trigger = triggerId ? document.getElementById(triggerId) : null;
      dialog.dataset.returnFocusId = '';
      if (trigger) trigger.focus({ preventScroll: true });
    });
  }

  function openDialog(trigger) {
    var dialogId = trigger.dataset.dialogId;
    var dialog = dialogId ? document.getElementById(dialogId) : null;
    if (!dialog || typeof dialog.showModal !== 'function') return;

    bindDialog(dialog);
    dialog.dataset.returnFocusId = trigger.id || '';
    var viewport = dialog.querySelector('[data-ingredient-list-scroll]');
    if (viewport) viewport.scrollTop = 0;
    dialog.showModal();
    document.documentElement.classList.add('ingredient-list-modal-open');

    var closeButton = dialog.querySelector('[data-ingredient-list-close]');
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function bindTrigger(trigger, index) {
    if (!trigger || trigger.dataset.ingredientListBound === 'true') return;
    trigger.dataset.ingredientListBound = 'true';
    if (!trigger.id) trigger.id = 'ingredient-list-trigger-' + index;

    trigger.addEventListener('click', function () {
      openDialog(trigger);
    });

    if (trigger.tagName !== 'BUTTON') {
      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openDialog(trigger);
      });
    }
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-ingredient-list-dialog]').forEach(bindDialog);
    root.querySelectorAll('[data-ingredient-list-open]').forEach(bindTrigger);
  }

  window.GarrnishIngredientListModal = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.GarrnishIngredientListModal.init(document);
    });
  } else {
    window.GarrnishIngredientListModal.init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    window.GarrnishIngredientListModal.init(event.target);
  });
})();

